import { Injectable } from '@angular/core';
import { PitchTitleService } from './pitch-title.service';
import { FaviconService } from './favicon.service';
import { CustomFavicon } from './favicon.config';
import { UserDivision } from './shared/types';

@Injectable({
  providedIn: 'root'
})
export class PitchPageMetaService {
  constructor(private titleService: PitchTitleService, private faviconService: FaviconService<CustomFavicon>) {}

  public setMeta(userDivision: UserDivision) {
    const icon = userDivision === 'WCM' ? CustomFavicon.WCM_ICON : CustomFavicon.WMG_ICON;
    this.titleService.setTitle(userDivision);
    this.faviconService.setCustomFavicon(icon);
  }
}
